import React from 'react'
import img from '../../../assets/icons/images/createddone.svg'

const CreationAdded = ({ onClose }) => {


    return (
        <div className='d-flex f-column aic jcc mt-24'>
            <img src={img} alt="creation-added" />
            <p className='fs-sm2 fw-bold fg-dark mt-24 mb-40 ta-center'>Good job! Now continue HYKing while we publish your creation...</p>

            <button className='btn red-outline-btn btn-xl btn-full rounded-xxl mb-24 fs-real fw-extra-bold' onClick={onClose}>CLOSE</button>
        </div>
    )
}

export default CreationAdded